import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { profile } from 'config/config'; // Importing profile configuration

/**
 * FilterMenuView class extends JetView to create a filter menu.
 */
export default class FilterMenuView extends JetView {
    /**
     * Configures the UI components of the filter menu.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 10,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'Country',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options to be populated later
                            id: 'Countries',
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the left section with country dropdown
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section], // Upper section with filters
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section with filters
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3], // Scrollable accordion section
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            id: 'formFilter',
            rows: [
                screen.width > 500 && screen.height > 500 // Responsive design
                    ? accordion_section
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        var vthis = this; // Reference to the current instance
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // List of partners

        /**
         * Filters partners based on the partner ID.
         * @param {Object} partners - The partner object to filter.
         * @returns {boolean} True if the partner ID matches.
         */
        function filter_partners(partners) {
            return partners.id == id_partner; // Check for matching partner ID
        }

        var partner = partners.filter(filter_partners); // Filter partners
        $$('Countries').define('options', partner[0].Countries); // Set country options
        $$('Countries').refresh(); // Refresh dropdown with new options

        $$('Countries').attachEvent('onChange', function (newv) {
            // Event handler for country change
            const filterdata = $$('formFilter').getValues(); // Get form values
            filterdata.Partner = partner[0].id; // Add partner ID to filter data
            vthis.app.callEvent('menu:filter', [filterdata]); // Trigger filter event
            $$('filterPopup').hide(); // Hide filter popup
            $$('b1').collapse(); // Collapse accordion section
        });
    }
}

// FILE DOCUMENTED
